import React from "react";
import { Link } from "react-router-dom";
import './index.less'
export default function Footer(props) {
	const item = [
		{name:'公司简介', Link:'/about',},
		{name:'知识产权', Link:'/zhishi',},
		{name:'荣誉证书', Link:'/rongyu',},
		{name:'公司新闻', Link:'/news',},
		{name:'合作与服务', Link:'/huoban',},
		{name:'加入我们', Link:'/joinus',},
		{name:'联系我们', Link:'/contact',},
	]
	return (
		<div className="aboutMenu">
			<ul>
				{item.map((item,index)=>(
					<li key={index} className={props.active == index ?'active':''}><Link to={item.Link}>{item.name}</Link></li>
				))}
			</ul>
		</div>
	);
}
